import { motion } from 'framer-motion';
import React from 'react';
interface CardProps {
  children: React.ReactNode;
}
export const FadeMotionBox = (props: CardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: 0.3,
      }}
    >
      {props.children}
    </motion.div>
  );
};
